module.exports = __webpack_public_path__ + "static/btc-d715f5a7f7de5a110b79af04784d322a.png";